"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppTheme = void 0;
const themes_1 = __importDefault(require("../themes"));
const themesConfig = {
    // BRANDS
    'a-rosa': Object.assign(Object.assign({}, themes_1.default.arosa), { type: 'brand' }),
    'blue-star': Object.assign(Object.assign({}, themes_1.default.bluestar), { type: 'brand' }),
    sensatori: Object.assign(Object.assign({}, themes_1.default.sensatori), { logo: '/images/brands/sensatori/logo-dark.svg', type: 'brand' }),
    sensimar: Object.assign(Object.assign({}, themes_1.default.tuiblue), { logo: '/images/brands/tui-blue/logo-white-horizontal.svg', type: 'brand' }),
    'tui-on-tour': Object.assign(Object.assign({}, themes_1.default.tuiontour), { logo: '/images/brands/tui-on-tour/logo.svg', type: 'brand' }),
    'tui-lapland': Object.assign(Object.assign({}, themes_1.default.tuilapland), { type: 'brand' }),
    'tui-blue': Object.assign(Object.assign({}, themes_1.default.tuiblue), { type: 'brand' }),
    'tui-blue-for-families': Object.assign(Object.assign({}, themes_1.default.tuiblue), { type: 'brand' }),
    'tui-blue-for-two': Object.assign(Object.assign({}, themes_1.default.tuiblue), { type: 'brand' }),
    'tui-magic-life': Object.assign(Object.assign({}, themes_1.default.tuimagiclife), { type: 'brand' }),
    'family-life': Object.assign(Object.assign({}, themes_1.default.familylife), { type: 'brand' }),
    gotthard: Object.assign(Object.assign({}, themes_1.default.gotthard), { type: 'brand' }),
    iberotel: Object.assign(Object.assign({}, themes_1.default.iberotel), { type: 'brand' }),
    interalpen: Object.assign(Object.assign({}, themes_1.default.interalpen), { type: 'brand' }),
    'robinson-club': Object.assign(Object.assign({}, themes_1.default.robinson), { type: 'brand' }),
    'villa-bulfon': Object.assign(Object.assign({}, themes_1.default.villabulfon), { type: 'brand' }),
    'vissi-d-arte': Object.assign(Object.assign({}, themes_1.default.vissidarte), { type: 'brand' }),
    'bachmair-weissach': Object.assign(Object.assign({}, themes_1.default.bachmairWeissach), { type: 'brand' }),
    '101-besten': Object.assign(Object.assign({}, themes_1.default.besten), { type: 'brand' }),
    // VENUES
    'interalpen-hotel-tyrol': Object.assign(Object.assign({}, themes_1.default.interalpenTyrol), { type: 'venue' }),
    'grand-hotel-kronenhof-pontresina': Object.assign(Object.assign({}, themes_1.default.kronenhof), { logo: '/images/brands/kronenhof/logo.svg', type: 'venue' }),
    'grand-hotel-heiligendamm': Object.assign(Object.assign({}, themes_1.default.heiligendamm), { logo: '/images/brands/heiligendamm/logo-heiligendamm.svg', type: 'venue' }),
    'schloss-elmau': Object.assign(Object.assign({}, themes_1.default.elmau), { logo: '/images/brands/schloss-elmau/logo.svg', type: 'venue' }),
    'dorfhotel-boltenhagen': Object.assign(Object.assign({}, themes_1.default.dorfhotelboltenhagen), { logo: '/images/brands/dorfhotel-boltenhagen/logo.svg', type: 'venue' }),
    'orania-berlin': Object.assign(Object.assign({}, themes_1.default.oraniaberlin), { logo: '/images/brands/orania-berlin/logo.svg', type: 'venue' }),
    'schwabinger-wahrheit': Object.assign(Object.assign({}, themes_1.default.schwabingerwahrheit), { logo: '/images/brands/geisel/schwabinger-wahrheit.svg', type: 'venue' }),
    'beyond-by-geisel': Object.assign(Object.assign({}, themes_1.default.beyondbygeisel), { logo: '/images/brands/geisel/beyond-by-geisel.svg', type: 'venue' }),
    'excelsior-by-geisel': Object.assign(Object.assign({}, themes_1.default.excelsiorbygeisel), { logo: '/images/brands/geisel/excelsior-by-geisel.svg', type: 'venue' }),
    kralleralm: Object.assign(Object.assign({}, themes_1.default.kralleralm), { logo: '/images/brands/krallerhof/kralleralm.svg', type: 'venue' }),
    asitzbraeu: Object.assign(Object.assign({}, themes_1.default.asitzbraeu), { logo: '/images/brands/krallerhof/asitzbraeu.svg', type: 'venue' }),
    alteschmiede: Object.assign(Object.assign({}, themes_1.default.alteschmiede), { logo: '/images/brands/krallerhof/alteschmiede.svg', type: 'venue' }),
    'torfhaus-harzresort': Object.assign(Object.assign({}, themes_1.default.torfhausharzresort), { logo: '/images/brands/harzresort/torfhaus-logo.svg', type: 'venue' }),
    'pizzeria-da-bruno': Object.assign(Object.assign({}, themes_1.default.pizzeriaDaBruno), { logo: '/images/brands/gerber/daBruno.svg', type: 'venue' }),
    'hotel-mooshaus-winterresort': Object.assign(Object.assign({}, themes_1.default.mooshaus), { type: 'venue' }),
    'hotel-alpenrose-kuehtai': Object.assign(Object.assign({}, themes_1.default.alpenroseKutai), { type: 'venue' }),
    'louis-c-jacob': Object.assign(Object.assign({}, themes_1.default.louiscjacob), { type: 'venue' }),
    'upstalsboom-wyk-auf-foehr': Object.assign(Object.assign({}, themes_1.default.upstalsboom), { type: 'venue' }),
    fallback: Object.assign(Object.assign({}, themes_1.default.generic), { logo: '/images/brands/generic/logo.svg', type: 'brand', isFallback: true }),
};
const getThemeFromConfig = (params) => {
    if (themesConfig[params.slug]) {
        return {
            theme: themesConfig[params.slug],
            type: themesConfig[params.slug].type,
        };
    }
    if (themesConfig[params.brand]) {
        return {
            theme: themesConfig[params.brand],
            type: themesConfig[params.brand].type,
        };
    }
    return { theme: themesConfig.fallback, type: 'brand' };
};
const mergeThemes = (baseTheme, backofficeStyles) => {
    // no backoffice styles
    if (!backofficeStyles || Object.keys(backofficeStyles).length === 0) {
        return themesConfig.fallback;
    }
    const explicitTheme = baseTheme.theme;
    // rely on backoffice
    if (explicitTheme.isFallback) {
        const helperObj = Object.assign({}, explicitTheme);
        Object.keys(backofficeStyles).map((style) => {
            if (backofficeStyles[style]) {
                helperObj[style] = backofficeStyles[style];
            }
            return null;
        });
        return helperObj;
    }
    // rely on explicit theming
    const helperObj = Object.assign({}, backofficeStyles);
    Object.keys(explicitTheme).map((style) => {
        helperObj[style] = explicitTheme[style];
        return null;
    });
    return helperObj;
};
const getAppTheme = (params, appTheme) => {
    const baseTheme = getThemeFromConfig(params);
    const completeTheme = mergeThemes(baseTheme, appTheme);
    // logo priority:
    // 1. hardcoded logos
    // 2. logos from the app theme ( logoUrl in this case )
    // 3. fallbach logo if none of the above is present
    let displayLogo = baseTheme.type === 'venue' && baseTheme.theme.logo ? baseTheme.theme.logo : appTheme.logoUrl;
    if (!displayLogo) {
        displayLogo = themesConfig.fallback.logo;
    }
    return Object.assign(Object.assign({}, completeTheme), { logo: displayLogo, 
        // added this because flow is a crybaby, it's not actually needed for anything else and won't break anything if removed
        fontFamily: completeTheme.fontFamily, colorPrimaryLighter: completeTheme.colorPrimaryLighter, colorPrimaryDarker: completeTheme.colorPrimaryDarker });
};
exports.getAppTheme = getAppTheme;
